import React, { useEffect, useState } from "react";
import { Form, Button, InputNumber, Select, Switch, Checkbox } from "antd";
import { typeForDetailsProyect } from "../../../types/typeModalDetailsProject";
import { useCheckFormMultiple } from "../../../hooks/useCheckFormMultiple";
import { useProjectHrsDetails } from "../../../hooks/useProjectHrsDetails";
import { ContainerModal } from "../../container/ContainerModal";
import { MessageAnt } from "../../../redux/slices/ui/uiAction";
import { truncateFloat } from "../../../helpers/generalHelper";
import { MessageType } from "../../../types/messageType";
import { IteamFormModal } from "./IteamFormModal";
import { IconErrorHrs } from "../../icons";

const areasData = {
    web: { label: "Programación Web", name: "web" },
    unity: { label: "Programación Unity", name: "unity" },
    design: { label: "Diseño UI/UX", name: "design" },
    modeling: { label: "Arte 3D", name: "art3d" },
};

const namesBack = {
    web: "webHours",
    unity: "unityHours",
    design: "designHours",
    art3d: "artHours",
};

const nivelsPercetTesting = (value = 5) => Array.from({ length: 101 / value }, (_, i) => i * value);

export const FormHoursProjectDetails = ({ dataForm = [], isSuperAdmin, editFormForProjectDetails, closeModalDetails }) => {

    const [form] = Form.useForm();

    const [loading, setLoading] = useState(false);

    const { hrsDeveloping, hrsPlanning, hrsToDistribute, inputsAreas, percentHrsTesting, simboleHrs, onFieldsChange, fillInData } =
        useProjectHrsDetails(areasData);

    const { checkValues, onChangueValue } = useCheckFormMultiple({
        isModeEditor: false,
    });

    const getJsonEditMode = ({ hrsDeveloping, hrsPlanning }) => {
        if (hrsPlanning > hrsDeveloping) {
            MessageAnt(MessageType.warning, "No puede ser mayor planeación que la horas de desarrollo");
            return;
        }
        return {
            developmentHours: hrsDeveloping,
            planningHours: hrsPlanning,
            type: 0,
        };
    };

    const getJsonHrs = ({ isTracing, percentHrsTesting, restAreas }) => {
        const getHrsByArea = Object.entries(restAreas).reduce((prev, [key, value = 0]) => {
            const valueTime = value || 0;
            return {
                ...prev,
                [namesBack[key]]: valueTime,
            };
        }, {});
        return {
            isTracing: isTracing,
            testing: percentHrsTesting,
            type: 1,
            ...getHrsByArea,
        };
    };

    const finishForm = async (values) => {
        if (hrsToDistribute < 0) {
            return;
        }
        setLoading(true);

        let jsonEndpoint = {};
        let isEditor = checkValues["isModeEditor"];
        const { percentTesting, isTracing, hrsPlanning, hrsDeveloping, ...restAreas } = values;
        if (isEditor) {
            jsonEndpoint = getJsonEditMode({ hrsDeveloping, hrsPlanning });
        } else {
            jsonEndpoint = getJsonHrs({ isTracing, percentHrsTesting, restAreas });
        }

        await editFormForProjectDetails(typeForDetailsProyect.hrsProjectDetails, jsonEndpoint);
        setLoading(false);

    };

    useEffect(() => {
        const formInit = fillInData(dataForm);
        form.setFieldsValue(formInit);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const moreHoursThanNeeded = hrsToDistribute < 0;

    return (
        <div className="fixed top-0 left-0 w-full h-full z-50 bg-black bg-opacity-45 flex justify-center items-center">
            <ContainerModal
                title={"Editar horas de desarrollo"}
                actionButton={() => {
                    closeModalDetails();
                }}
                className={"w-[500px]"}
            >
                <Form form={form} onFinish={finishForm} className="w-full h-full" onFieldsChange={onFieldsChange}>
                    <div className="h-full w-full flex flex-col gap-4">
                        <div className="w-full flex gap-4">
                            <div className="bg-[#7FFFD5] w-[50px] flex justify-center items-center">
                                <p>{simboleHrs}</p>
                            </div>
                            <div className="">
                                <p>Horas Totales</p>
                            </div>
                            <div className="">
                                <p className="font-semibold">{truncateFloat(hrsPlanning + hrsDeveloping)}</p>
                            </div>
                            <div className="">
                                <p>Horas por distribuir</p>
                            </div>
                            <div className="">
                                <p className="font-semibold">{truncateFloat(hrsToDistribute)}</p>
                            </div>
                        </div>
                        {moreHoursThanNeeded && (
                            <div className=" flex items-center gap-2">
                                <div className="">
                                    <IconErrorHrs />
                                </div>
                                <p className="text-[#E4404B]">¡Advertencia! Has excedido el tiempo de desarrollo asignado.</p>
                            </div>
                        )}
                        <div className="flex gap-4">
                            <div className="flex gap-4">
                                <div className="w-[80px]">
                                    <p>Horas de planeación</p>
                                </div>
                                <Form.Item name={"hrsPlanning"} className="h-full ">
                                    <InputNumber min={1} disabled={!checkValues["isModeEditor"]} />
                                </Form.Item>
                            </div>
                            <div className="flex">
                                <div className="w-[80px]">
                                    <p>Horas de desarrollo</p>
                                </div>
                                <Form.Item name={"hrsDeveloping"} className="h-full ">
                                    <InputNumber min={1} disabled={!checkValues["isModeEditor"]} />
                                </Form.Item>
                            </div>
                        </div>
                        <IteamFormModal title="Horas presupuestadas">
                            <div className="w-full grid grid-cols-3">
                                {inputsAreas.map((inputArea, index) => (
                                    <div key={`${index}-input-area`} className=" flex flex-col gap-2">
                                        <p>{inputArea.label} </p>
                                        <Form.Item name={inputArea.name}>
                                            <InputNumber min={0} disabled={checkValues["isModeEditor"]} onChange={(value) => {
                                                return 30
                                            }} />
                                        </Form.Item>
                                    </div>
                                ))}
                                <div className=" flex flex-col gap-2">
                                    <p>Testing</p>
                                    <Form.Item name={"percentTesting"}>
                                        <Select showSearch placeholder={`Testing`} className="w-[60%]" disabled={checkValues["isModeEditor"]}>
                                            {nivelsPercetTesting(5).map((valuePercent, index) => (
                                                <Select.Option key={`${index}-percentvalue`} value={valuePercent}>
                                                    <span>{valuePercent}%</span>
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </div>
                                <div className=" flex flex-col gap-2">
                                    <p>Testing</p>
                                    <div className="w-[60%] p-2 bg-[#EFF2F5] rounded-[4px]">
                                        <p className="text-gray-500">{percentHrsTesting}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="flex gap-4 items-center h-[40px]">
                                <p>Seguimiento</p>
                                <Form.Item className="flex items-end mt-6" name="isTracing" valuePropName="checked">
                                    <Checkbox disabled={checkValues["isModeEditor"]} />
                                </Form.Item>
                                {isSuperAdmin && (
                                    <>
                                        <p>Modo editor</p>
                                        <Switch
                                            checked={checkValues["isModeEditor"]}
                                            onChange={(value) => {
                                                onChangueValue("isModeEditor", value);
                                            }}
                                            size="small"
                                            className={`${checkValues["isModeEditor"] ? "bg-primaryTwo" : "bg-[#CDCDCD]"}`}
                                        />
                                    </>
                                )}
                            </div>
                        </IteamFormModal>
                        <div className="w-full h-[40px] mt-4 overflow-hidden flex justify-end gap-4">
                            <Button htmlType="button" onClick={closeModalDetails}>
                                Cancelar
                            </Button>
                            <Button disabled={moreHoursThanNeeded} type="primary" htmlType="submit" className="bg-primaryTwo disabled:bg-[#BFBFBF]" loading={loading}>
                                Guardar
                            </Button>
                        </div>
                    </div>
                </Form>
            </ContainerModal>
        </div>
    );
};
